import { NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { HttpClientModule } from '@angular/common/http';
import { ApplicationRef, NgModule } from '@angular/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatNativeDateModule } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NavigationEnd, Router } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgxdModule } from '@ngxd/core';
import { registerSpaLinkTag } from '@spa/built-in-dom-elements-extend/a-tag';
import { environment } from '@spa/environment';
import { UpdateTickersByRequestsInterceptorProvider } from '@spa/facade/features/tickers/update-tickers-by-requests-interceptor';
import { UserSettingsModule } from '@spa/facade/features/user-settings';
import { CoreModule } from '@valhalla/core';
import { DataHttpModule } from '@valhalla/data/http';
import { DataSignalrModule } from '@valhalla/data/signalr';
import { LocalizationModule } from '@valhalla/localization';
import { debounceTime, filter } from 'rxjs/operators';
import { LicenseManagerModule } from '../license-manager';

import { RoutingModule } from '../routing';
import { BootstrapComponent } from './bootstrap.component';
import { LocaleProvider } from './lazy-ng-locale';
import { PostBootstrapService } from './post-bootstrap.service';
import { resourceProviders } from './resource-providers';

if (!environment.production) {
	(window as any).__IS_DEV__ = true;
}

registerSpaLinkTag();

@NgModule({
	imports: [
		BrowserModule,
		// NoopAnimationsModule,
		BrowserAnimationsModule,
		ServiceWorkerModule.register('./ngsw-worker.js', { enabled: environment.production }),
		HttpClientModule,
		DataHttpModule.forRoot(),
		DataSignalrModule,
		CoreModule.withConfig({ isProduction: environment.production }),
		RoutingModule,
		NgxdModule,
		NgxMatNativeDateModule,
		LocalizationModule.forRoot({
			refreshOnChangeLanguage: true,
		}),
		UserSettingsModule.forRoot(),
		MatMomentDateModule,
		MatNativeDateModule,
		LicenseManagerModule.forRoot(),
	],
	declarations: [BootstrapComponent],
	bootstrap: [BootstrapComponent],
	providers: [
		...resourceProviders,
		PostBootstrapService,
		...LocaleProvider,
		UpdateTickersByRequestsInterceptorProvider,
	],
})
export class BootstrapModule {
	constructor(router: Router, app: ApplicationRef) {
		router.events
			.pipe(
				filter(event => event instanceof NavigationEnd),
				debounceTime(50)
			)
			.subscribe(() => {
				app.tick();
			});
	}
}
